/**
 * @author vishwadeep.kapoor
 * RestaurantDeals constants
 *
 */
import { eventTracking } from '../../devUtils';

export const DEFAULT_ACTION = '/RestaurantDeals/DEFAULT_ACTION';
export const FETCH_GDD_DATA = '/RestaurantDeals/FETCH_GDD_DATA';
export const FETCH_GDD_DATA_ERROR = '/RestaurantDeals/FETCH_GDD_DATA_ERROR';
export const FETCH_GDD_DATA_SUCCESS = '/RestaurantDeals/FETCH_GDD_DATA_SUCCESS';
export const CHANGE_SEARCH_FORM = '/RestaurantDeals/CHANGE_SEARCH_FORM';

/**
 * @todo need to use the switch case for all cases for analytics
 */
export const TRIGGER_TRACKER = (type, value, otherProps) => {
  let actionType = '';
  switch (otherProps) {
    case 'category':
      actionType = 'Landing Page Categories';
      break;
    case 'Collections':
      actionType = 'Landing Page Collections';
      break;
    case 'tag_types':
      actionType = 'Landing Page Deal Types';
      break;
    case 'cuisines':
      actionType = 'Landing Page Cuisines';
      break;
    case 'innerSearch':
      actionType = 'Landing Page Search';
      break;
    case 'locations':
      actionType = 'Landing Page Locations';
      break;

    default:
      actionType = '';
      break;
  }
  return eventTracking.triggerEvent('Restaurant Deals', actionType, value);
};



// WEBPACK FOOTER //
// client/containers/RestaurantDeals/constants.js